module.exports = __webpack_public_path__ + "img/ic_area.0cd2b88e.svg";